import { render, staticRenderFns } from "./hdqSection.vue?vue&type=template&id=5f0040d1&scoped=true"
import script from "./hdqSection.vue?vue&type=script&lang=js"
export * from "./hdqSection.vue?vue&type=script&lang=js"
import style0 from "./hdqSection.vue?vue&type=style&index=0&id=5f0040d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0040d1",
  null
  
)

export default component.exports